// PushBootstrap — invokes usePushNotifications() once, above the router
// outlet. Only does work after the user is authenticated.

import { usePushNotifications } from './usePushNotifications';

export function PushBootstrap() {
  usePushNotifications();
  return null;
}
